import React from 'react';
import styles from '../../css/download.module.css'

const Downloads = () => {


  return (
    <div>
      <div id={styles.sub_con_warp}>
        <div className={styles.sub21_con01}>
          <ul>
            <li>
              <div className={styles.sub21_con01_title01}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>관제 프로그램</p>
                <p className={styles.sub21_text02}>사용자 편의에 따라 커스텀 설정 가능</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <a className={styles.sub21_con01_2_right} href="https://devdownload.deliverycatch.com/releases/catch_manager_latest.apk?v=250109a">
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>   
                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    WEB
                  </div>
                  <a className={styles.sub21_con01_2_right} href="https://admin.deliverycatch.com/" alt="CATCH 관제" target="_blank" rel='noreferrer'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title02}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>상점용 프로그램</p>
                <p className={styles.sub21_text02}>남녀노소 쉽게 사용 가능한 간편한 조작</p>
 
                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    PC, POS (Windows)/Exe
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/releases/prod/setup.exe?v=250122a'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                  PC, POS (Windows)/Zip
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/releases/prod/CatchShop_1_6_4_31.zip'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title03}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>기사용 프로그램</p>
                <p className={styles.sub21_text02}>실시간 오더 위치 확인</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/releases/rider/catch_rider_v1.23.0.apk'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (ios)
                  </div>
                  <div className={styles.sub21_con01_2_right} onClick={() => alert('준비중입니다.')}>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title04}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>원격 제어</p>
                <p className={styles.sub21_text02}>사용자 편의를위해 원격 제어를 제공합니다. </p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    원격제어 프로그램
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://anydesk.com/ko/downloads/thank-you?dv=win_exe' target='_blank' rel='noreferrer'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title04}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>기타 프로그램</p>
                <p className={styles.sub21_text02}>기타 다양한 프로그램</p> 
                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    .NET 프레임워크 4.6.2 
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://dotnet.microsoft.com/ko-kr/download/dotnet-framework/thank-you/net462-web-installer' target='_blank' without rel="noreferrer">
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div> 
                
                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    HHD 시리얼포트 모니터링 3.0.1 
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/dist/hhdspmc.exe'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div> 

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                  윈도우7 IE11 32비트
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/dist/etc/EIE11_KO-KR_MCM_WIN7.EXE'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div> 
                
                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                  윈도우7 IE11 64비트
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/dist/etc/EIE11_KO-KR_MCM_WIN764.EXE'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div> 
              </div>
            </li> 
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Downloads;
